import { FC } from 'react';
import { InnerIconProps, withIcon } from '@tempusfinance/common-ui';

const TransactionSwapComponent: FC<InnerIconProps> = ({ size, color }) => {
  const colorVar = `var(--icon-color, var(${color}))`;

  return (
    <svg
      className="nostra__icon nostra__icon__transactionSwap"
      width={size}
      height={size}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="7" cy="7" r="6.5" fill="#DAE1F5" stroke="white" />
      <g clipPath="url(#clip0_3381_2048)">
        <path
          d="M10 8.66675L8.66667 10.0001L7.33333 8.66675"
          stroke={colorVar}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M8.66669 4.5L8.66669 10" stroke={colorVar} strokeLinecap="round" strokeLinejoin="round" />
        <path
          d="M4.00002 5.33333L5.33335 4L6.66669 5.33333"
          stroke={colorVar}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M5.33331 9.5L5.33331 4" stroke={colorVar} strokeLinecap="round" strokeLinejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_3381_2048">
          <rect width="8" height="8" fill="white" transform="translate(3 3)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const TransactionSwap = withIcon(TransactionSwapComponent);
